module.exports = __webpack_public_path__ + "static/media/ketchup-removebg-preview.6ed20d30.png";